import React, { forwardRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";

export interface IPullquoteProps extends IEditableProps, IStyledProps {
    title: string;
    pullquoteBody: string;
    byline: string;
    backgroundColor;
    fontColor;
    cmsId?: string;
    editorClassObj?: any;
}

const Pullquote = forwardRef((props: IPullquoteProps, ref: any) => {
    const { title, pullquoteBody, byline, backgroundColor, fontColor, editorClassObj, className, cmsId } = props;

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj, backgroundColor, fontColor, 'p-4 rounded-lg')}>
            <p>
                <small>{title}</small>
            </p>
            <p className={classNames("pullquote-body position-relative", {"quotes": Boolean(pullquoteBody)})}>
                {pullquoteBody}
            </p>
            <p className="font-weight-bold">{byline}</p>
        </div>
    )
});

export default styled(Pullquote)`
    .pullquote-body.quotes {
        &:before, &:after {
            content: '"';
            display: inline;
        }
        &:before {
            top: 0;
            margin-left: -8px;
        }
    }
`;